import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import logo from '../assets/img/logo-2.svg';
import movexLogo from '../assets/img/movexLogo.png';
import nextGearLogo from '../assets/img/nextGearLogo.png';
import imdaLogo from '../assets/img/imdaLogo.png';
import googlePlayQrCode from '../assets/img/googlePlayQrCode.png';
import appleStoreQrCode from '../assets/img/appleStoreQrCode.png';
import googlePlay from '../assets/img/googlePlay.svg';
import appleStore from '../assets/img/appleStore.svg';
import { InformationForUsersList } from '../constants/FooterNavList';
import RouterPaths from '../constants/RouterPaths';
import { scrollIntoView } from '../common/helpers/scrollIntoView';

const MOBILE_APP_GOOGLE_PLAY_URL = process.env.REACT_APP_MOBILE_APP_GOOGLE_PLAY_URL;
const MOBILE_APP_APPLE_STORE_URL = process.env.REACT_APP_MOBILE_APP_APPLE_STORE_URL;

function FooterNav() {
  const navigate = useNavigate();
  const isAuthenticated = useSelector((state) => state.auth.get('isAuthenticated'));
  const getCurrentYear = () => new Date().getFullYear();

  const _renderCopyright = () => (
    <p className="footer-nav-copyright">Copyright © {getCurrentYear()} The Stock Vault.</p>
  );

  const handleRedirectForDealerAuction = (e, route) => {
    e.preventDefault();
    if (isAuthenticated) {
      return navigate(route);
    }
    return scrollIntoView(route === RouterPaths.MY_VEHICLES ? 'sell-car' : 'buy-car');
  };

  return (
    <div className="footer-nav">
      <div className="footer-nav__row-item">
        <div className="footer-nav__row-item-logo">
          <Link to={RouterPaths.DASHBOARD}>
            <img className="footer-logo" src={logo} alt="Page logo - The Stock Vault" />
          </Link>
        </div>
        <div>{_renderCopyright()}</div>
      </div>
      <div className="footer-nav__row-item">
        <div className="footer-nav__list-wrapper">
          <ul className="footer-nav__list">
            <span className="footer-nav__list-title">The Stock Vault</span>
            <li key={InformationForUsersList.buyers.path} className="footer-nav__list-item">
              <Link
                to="#buy-car"
                className="footer-nav__list-item-link"
                onClick={(e) => handleRedirectForDealerAuction(e, RouterPaths.MY_BIDS)}
              >
                <span>{InformationForUsersList.buyers.label}</span>
              </Link>
            </li>
            <li key={InformationForUsersList.sellers.path} className="footer-nav__list-item">
              <Link
                to="#sell-car"
                className="footer-nav__list-item-link"
                onClick={(e) => handleRedirectForDealerAuction(e, RouterPaths.MY_VEHICLES)}
              >
                <span>{InformationForUsersList.sellers.label}</span>
              </Link>
            </li>
            <li key={InformationForUsersList.contactUs.path} className="footer-nav__list-item">
              <Link
                to={InformationForUsersList.contactUs.path}
                className="footer-nav__list-item-link"
              >
                <span>{InformationForUsersList.contactUs.label}</span>
              </Link>
            </li>
            <li
              key={InformationForUsersList.nextGearCapital.path}
              className="footer-nav__list-item"
            >
              <Link
                to={InformationForUsersList.nextGearCapital.path}
                className="footer-nav__list-item-link"
              >
                <span>{InformationForUsersList.nextGearCapital.label}</span>
              </Link>
            </li>
          </ul>
        </div>
        <div className="footer-nav__list-wrapper">
          <ul className="footer-nav__list">
            <span className="footer-nav__list-title">Terms</span>
            <li
              key={InformationForUsersList.privacyPolicy.path}
              className="footer-nav__list-item"
            >
              <Link
                to={InformationForUsersList.privacyPolicy.path}
                className="footer-nav__list-item-link"
              >
                <span>{InformationForUsersList.privacyPolicy.label}</span>
              </Link>
            </li>
            <li
              key={InformationForUsersList.cookiePolicy.path}
              className="footer-nav__list-item"
            >
              <Link
                to={InformationForUsersList.cookiePolicy.path}
                className="footer-nav__list-item-link"
              >
                <span>{InformationForUsersList.cookiePolicy.label}</span>
              </Link>
            </li>
            <li
              key={InformationForUsersList.termsAndConditions.path}
              className="footer-nav__list-item"
            >
              <Link
                to={InformationForUsersList.termsAndConditions.path}
                className="footer-nav__list-item-link"
              >
                <span>{InformationForUsersList.termsAndConditions.label}</span>
              </Link>
            </li>
            <li
              key={InformationForUsersList.feesInformation.path}
              className="footer-nav__list-item"
            >
              <Link
                to={InformationForUsersList.feesInformation.path}
                className="footer-nav__list-item-link"
              >
                <span>{InformationForUsersList.feesInformation.label}</span>
              </Link>
            </li>
          </ul>
        </div>
        <div className="footer-nav__list-wrapper">
          <ul className="footer-nav__list">
            <span className="footer-nav__list-title footer-nav__mobile-apps-header">
              Mobile Apps
            </span>
            <div className="footer-nav__mobile-apps">
              <div className="footer-nav__mobile-apps-item">
                <p className="footer-nav__mobile-app-type">Android</p>
                <a href={MOBILE_APP_GOOGLE_PLAY_URL}>
                  <img
                    className="footer-nav__qr-code"
                    src={googlePlayQrCode}
                    alt="Google Play QR Code"
                  />
                  <img
                    className="footer-nav__google-play"
                    src={googlePlay}
                    alt="Google Play"
                  />
                </a>
              </div>
              <div className="footer-nav__mobile-apps-item">
                <p className="footer-nav__mobile-app-type">iOS</p>
                <a href={MOBILE_APP_APPLE_STORE_URL}>
                  <img
                    className="footer-nav__qr-code"
                    src={appleStoreQrCode}
                    alt="Apple Store QR Code"
                  />
                  <img
                    className="footer-nav__apple-store"
                    src={appleStore}
                    alt="Apple Store"
                  />
                </a>
              </div>
            </div>
          </ul>
        </div>
        <div className="footer-nav__list-wrapper">
          <ul className="footer-nav__list">
            <span className="footer-nav__list-title">Our Partners</span>
            <div className="footer-nav__partners">
              <Link
                to={InformationForUsersList.nextGearCapital.path}
                className="footer-nav__list-item-link"
              >
                <img
                  className="footer-nav__partners-logo"
                  src={nextGearLogo}
                  alt="Next Gear Logo"
                />
              </Link>
              <img className="footer-nav__partners-logo" src={movexLogo} alt="Movex Logo" />
              <img className="footer-nav__partners-logo" src={imdaLogo} alt="IMDA Logo" />
            </div>
          </ul>
        </div>
      </div>
      <div className="footer-nav__row-item">{_renderCopyright()}</div>
    </div>
  );
}

export default FooterNav;
